export const START_TEST = "START_TEST";
export const TOGGLE_VIEW = "TOGGLE_VIEW";
export const NAVIGATE_TO_QUESTION = "NAVIGATE_TO_QUESTION";
export const ANSWER_FIELD_CHANGE = "ANSWER_FIELD_CHANGE";
export const CLEAR_SECTION = "CLEAR_SECTION";
export const MARK_FOR_REVIEW = "MARK_FOR_REVIEW";
export const TEST_AREA_SUBMIT = "@@testArea/submit";
export const SUBMIT_TEST = "SUBMIT_TEST";
